"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFundingSubmissionComponentArray = void 0;
const FundingRequest_1 = require("../types/FundingRequest");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isFundingSubmissionComponentArray = (0, typeguardUtils_1.zodArrayTypeGuard)(FundingRequest_1.FundingSubmissionComponentSchema);
//# sourceMappingURL=fundingRequest.js.map